import { safeGet } from './safeGet'

// A user can export if they hold either the plain export permission or the all-revisions one.
export function hasExportPermission(permissions) {
  return safeGet(
    () => !!(permissions.userPermissions.canExport || permissions.userPermissions.canExportAllRevisions),
    false
  )
}
